import React from "react";
import { ProductListScreenContext } from "./context";

export const useProductListScreen = () => {
  const context = React.useContext(ProductListScreenContext);

  if (!context)
    throw new Error(
      "useProductListScreen must be used within a ProductListScreen Provider"
    );

  return context;
};
